import React from "react";
import style from './Profile.module.css';


const Profile = () => {
    let pathVideos = '/videos';
    let pathPhotos = '/photos';
    let pathFriends = '/friends';
    return (
        <div className={style.profileBox}>
            <div className={style.myAvatarImg}>
                <img src="https://www.layeredonline.com/wp-content/uploads/2018/07/HairCrushJessDay3-1.jpg"></img>
            </div>
            <nav className={style.profileNav}>
                <div className={style.myName}>
                    <h3 className={style.myNameHeader}>Jessica Day</h3>
                    <p className={style.myLocation}>New York, USA</p>
                </div>
            
                <div className={style.navList}>
                    <a className={style.navItem} href="#">About Me</a>
                    <a className={style.navItem} href={pathFriends}>Followers</a>
                    <a className={style.navItem} href={pathPhotos}>Photos</a>
                    <a className={style.navItem} href={pathVideos}>Videos</a>
                </div>
            </nav>
        </div>
    )
}

export default Profile;